(function() {
	'use strict';
	
    var Faq = ctme.Faq = function () { },
        faq = document.getElementById('faq');
		
	Faq.prototype.init = function() {
	
	    var items = document.getElementsByClassName('js-faq');

        var action = function(e) {
            if (e.target.parentNode.classList.contains('is-active')) {
                
                e.target.parentNode.classList.remove('is-active');

                
            } else {
                for (var i = 0; i < items.length; i ++) {
                    items[i].classList.remove('is-active');
                }
                e.target.parentNode.classList.add('is-active');
            }
            e.returnValue = false;
        };
        

        faq.addEventListener('click', function(e) {
            if (e.target.parentNode.classList.contains('js-faq')) action(e);
        }, false);
	};

	ctme.Faq = new Faq();

    if (faq !== null) ctme.Faq.init();


}(window.ctme = window.ctme || {}));

